module.exports = __webpack_public_path__ + "img/dasboardHub.a423d0b0.png";